export function history () {
  const historyHomepage = document.querySelector('#homepage__ul');

  const historyPage = document.querySelector('#history__ul');

  fetch('assets/generated.json')
    .then(response => {
      return response.json();
    })
    .then(json => {
      const target = document.body.getAttribute('content');

      if (target == 'homepage') {
        historyDisplay(json, 3, historyHomepage);
      } else if (target == 'history') {
        historyDisplay(json, 9, historyPage);
      }
    });

  function historyDisplay (json, amount, source) {
    source.innerHTML = '';
    for (let i = 0; i < amount; i++) {
      const li = document.createElement('li');
      if (i < (amount - 1)) { li.classList.add('history__el', 'history__el--bordered'); } else { li.classList.add('history__el'); }

      li.setAttribute('data-id', json[i].id);

      li.innerHTML = `<a href="#">
            <div class="history__img">
              <img src="${json[i].picture}" alt="Historique de point"/>
            </div>
            <div class="history__content">
              <h3 class="history__points">
                <span class="history__span">${json[i].points}</span> 
                points
              </h3>
              <p class="history__date">
              ${json[i].date[2] + ' ' + json[i].date[1] + ' ' + json[i].date[0]}
              </p>
            </div>
          </a>`;

      source.append(li);

      // Ecouter le click sur un li
      li.addEventListener('click', (e) => {
        e.preventDefault();

        // Création du ticket
        const ulTicket = document.createElement('ul');
        ulTicket.classList.add('ticket');

        const liOpen = document.createElement('li');
        liOpen.classList.add('history__el', 'history__el--bordered');
        liOpen.setAttribute('data-id', json[i].id);

        json[i].elements.forEach(element => {
          const liTicket = document.createElement('li');
          liTicket.classList.add('ticket__element');

          liTicket.innerHTML = `
              <div class="ticket__img">
                      <img src="${element.img}" alt="#">
                    </div>
                    <div class="ticket__content">
                      <h5 class="ticket__title">${element.name}</h5>
                      <div class="ticket__data">
                        <p><span>Points:</span> ${element.points}</p>
                        <p><span>CO2:</span> ${element.gas}</p>
                        <p><span>Trajets:</span>  ${element.road}</p>
                      </div>
                </div>
          `;

          ulTicket.append(liTicket);
        });

        // Remise à zéro de la liste
        source.innerHTML = '';

        // On réécrit l'en-tête du ticket
        liOpen.innerHTML = `<a href="#">
              <div class="history__img">
                <img src="${json[i].picture}" alt="Historique de point"/>
              </div>
              <div class="history__content">
                <h4 class="history__points">
                  <span class="history__span">${json[i].points}</span> 
                  points
                </h4>
                <p class="history__date">
                ${json[i].date[2] + ' ' + json[i].date[1] + ' ' + json[i].date[0]}
                </p>
              </div>
            </a>`;

        liOpen.append(ulTicket);

        source.append(liOpen);

        // On change le style de la flèche qui est en before
        const styleElem = document.head.appendChild(document.createElement('style'));
        styleElem.innerHTML = ".history__el a:before {background: url('/assets/images/svg/arrow-desc.svg'); background-repeat: no-repeat; background-size: contain;}";

        // On écoute le click à nouveau
        liOpen.addEventListener('click', (el) => {
          el.preventDefault();

          // On remet à zéro la flèche en supprimant la balise style du head
          var hs = document.getElementsByTagName('style');
          for (var j = 0, max = hs.length; j < max; j++) {
            hs[j].parentNode.removeChild(hs[j]);
          }

          // On réécrit la liste
          const target = document.body.getAttribute('content');

          if (target == 'homepage') {
            historyDisplay(json, 3, historyHomepage);
          } else if (target == 'history') {
            historyDisplay(json, 9, historyPage);
          }
        });
      });
    }
  }
}
